import { Button, Form, Icon, Input, message, Modal, Upload } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import * as React from 'react';
import withStyles from 'react-jss';
import { SETask } from 'src/dto/response/fetchShipmentTasks';
import useInput from 'src/hooks/form/useInput';
import useDocument from 'src/hooks/form/useDocument';
import { createStyles } from 'src/hooks/useStyles';
import { StylesProps } from 'src/Library/Types';
import { useGenericState } from 'src/Library/UseGenericState';
import SEFieldInput from '../../../SECommon/SEFieldInput';
import Asterisk from 'src/components/common/Asterisk';

const styles = createStyles((theme) => ({
  modal: {
    '& .ant-modal-body': {
      padding: 0,
    },
  },
  content: {
    padding: 15,
    '& .ant-tabs-content': {
      padding: 15,
      border: '1px solid #0000000d',
      marginTop: -3,
      height: 330,
      overflow: 'overlay',
    },
  },
}));

interface SETaskRejectionRemarkModalProps
  extends FormComponentProps<any>,
    StylesProps<ReturnType<typeof styles>> {
  handleClose: (refresh?: boolean) => Promise<void>;
  visible: boolean;
  handleSubmit: ({
    rejectionReason,
    rejectionDocumentUrl,
  }: {
    rejectionReason: string;
    rejectionDocumentUrl: string;
  }) => void;
  taskDetails: any;
  isRejectLoading: boolean;
}

const SETaskRejectionRemarkModal: React.FC<SETaskRejectionRemarkModalProps> = ({
  form,
  classes,
  handleClose,
  handleSubmit,
  visible,
  taskDetails,
  isRejectLoading,
}) => {
  const initialState = {
    s3File: '',
  };
  const [state, setState] = useGenericState(initialState);
  const { s3File } = state;
  const rejectionReason = useInput({
    form,
    disabled: false,
    visible: true,
    key: 'rejectionReason',
    label: 'Remark',
    placeholder: 'Type here...',
  });

  const rejectionAttachment = useDocument({
    form,
    multi: false,
    onClickSampleDownload: async () => {},
  });

  React.useEffect(() => {
    if (!rejectionAttachment.isUploading && rejectionAttachment?.s3File?.s3Link) {
      setState({
        s3File: rejectionAttachment.s3File.s3Link,
      });
    }
  }, [rejectionAttachment.isUploading]);

  const handleFileRemove = (e) => {
    if (e?.file?.status === 'removed') {
      setState({
        s3File: '',
      });
    }
  };

  const handleRejectModalSubmit = () => {
    let errorMsg = '';
    const isValuePresent = rejectionReason.value;
    if (!isValuePresent) {
      errorMsg += 'Rejection reason cannot be empty. ';
    }
    if (taskDetails.isRejectionDocumentRequired && !s3File) {
      errorMsg += `${!isValuePresent ? 'The ' : ''}Document need${
        !isValuePresent ? 's' : ''
      } to be attached for rejection. `;
      return message.error(errorMsg);
    }
    if (errorMsg) {
      return message.error(errorMsg);
    }
    handleSubmit({
      rejectionReason: rejectionReason.value,
      rejectionDocumentUrl: s3File,
    });
    return null;
  };

  const renderModalContent = () => {
    return (
      <div>
        {/* {rejectionReason.label} */}
        {rejectionReason.decorator(<Input.TextArea />)}
        <div>
          <div>
            Reference Document {taskDetails.isRejectionDocumentRequired ? <Asterisk /> : ''}
          </div>
          <div>
            {rejectionAttachment.decorator(
              <Upload disabled={rejectionAttachment.isUploading} onChange={handleFileRemove}>
                <Button
                  icon="upload"
                  type="link"
                  style={{ padding: '0px', marginTop: '5px' }}
                  disabled={rejectionAttachment.isUploading}
                >
                  Upload File
                </Button>
              </Upload>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <Modal
      className={classes.modal}
      width="45%"
      visible={visible}
      closable={true}
      title="Remark for Rejection"
      onCancel={() => handleClose()}
      onOk={() => handleRejectModalSubmit()}
      okButtonProps={{ disabled: rejectionAttachment.isUploading, loading: isRejectLoading }}
      okText="Submit"
      cancelText="Don't Reject"
    >
      <div className={classes.content}>{renderModalContent()}</div>
    </Modal>
  );
};

export default React.memo(withStyles(styles)(Form.create({})(SETaskRejectionRemarkModal)));
